import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const PH = ["{skonto_prozent}", "{skonto_betrag}", "{zahlbetrag}", "{brutto}", "{skonto_tage}", "{bezahlt_am}"];

// Einstellungen: Skonto auf der sevDesk-Rechnung (Skontofrist + Hinweistexte)
export function SkontoRechnungFields({ company, setCompany }) {
  const set = (k) => (e) => setCompany((c) => ({ ...c, [k]: e.target.value }));
  return (
    <div className="space-y-3 rounded-md border border-slate-200 p-3" data-testid="company-skonto-rechnung">
      <div>
        <p className="text-sm font-medium text-slate-900">Skonto auf der Rechnung (sevDesk)</p>
        <p className="text-xs text-slate-500">Hat der Kunde Überweisung gewählt, wird das Skonto als Zahlungsbedingung auf der Rechnung gesetzt (voller Rechnungsbetrag, kein Rabatt). Beim Zuordnen der Bankbuchung bucht sevDesk die Differenz als Skonto.</p>
      </div>
      <div className="w-72">
        <Label htmlFor="company-skonto-zahlungsziel">Zahlungsziel ohne Abzug (Tage)</Label>
        <Input id="company-skonto-zahlungsziel" type="number" min={2} max={365} inputMode="numeric" value={company.skonto_rechnung_zahlungsziel_tage ?? 30}
          onChange={(e) => setCompany((c) => ({ ...c, skonto_rechnung_zahlungsziel_tage: e.target.value === "" ? "" : Number(e.target.value) }))}
          onBlur={() => setCompany((c) => ({ ...c, skonto_rechnung_zahlungsziel_tage: Math.min(365, Math.max(2, Math.round(Number(c.skonto_rechnung_zahlungsziel_tage) || 30))) }))} data-testid="company-skonto-zahlungsziel-input" />
        <p className="text-xs text-slate-500 mt-1">sevDesk druckt: „Zahlung innerhalb von [Skontofrist] Tagen – X % Skonto, innerhalb von [Zahlungsziel] Tagen ohne Abzüge“. Das Zahlungsziel liegt immer mindestens einen Tag nach der Skontofrist.</p>
      </div>
      <div className="w-40">
        <Label htmlFor="company-skonto-tage">Skontofrist (Tage)</Label>
        <Input id="company-skonto-tage" type="number" min={1} max={365} inputMode="numeric" value={company.skonto_rechnung_tage ?? 14}
          onChange={(e) => setCompany((c) => ({ ...c, skonto_rechnung_tage: e.target.value === "" ? "" : Number(e.target.value) }))}
          onBlur={() => setCompany((c) => ({ ...c, skonto_rechnung_tage: Math.min(365, Math.max(1, Math.round(Number(c.skonto_rechnung_tage) || 14))) }))} data-testid="company-skonto-tage-input" />
      </div>
      <div>
        <Label htmlFor="company-skonto-rechnung-text">Hinweis auf der Rechnung</Label>
        <Textarea id="company-skonto-rechnung-text" rows={2} value={company.skonto_rechnung_text ?? ""} onChange={set("skonto_rechnung_text")} data-testid="company-skonto-rechnung-text-input" />
      </div>
      <div>
        <Label htmlFor="company-skonto-rechnung-bezahlt">Zusatz, wenn bereits bezahlt</Label>
        <Input id="company-skonto-rechnung-bezahlt" value={company.skonto_rechnung_text_bezahlt ?? ""} onChange={set("skonto_rechnung_text_bezahlt")} data-testid="company-skonto-rechnung-bezahlt-input" />
      </div>
      <p className="text-xs text-slate-500">Platzhalter: {PH.map((p) => <code key={p} className="font-mono bg-slate-100 px-1 rounded mr-1">{p}</code>)}</p>
    </div>
  );
}
